import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { listNotifications, markNotificationsRead } from '../../api/account.ts';
import { formatRelative } from '../../lib/format.ts';
import { EmptyState } from '../common/EmptyState.tsx';
import { IconCheck, IconShare } from '../../lib/icons.tsx';

export function NotificationsTab() {
  const queryClient = useQueryClient();
  const { data, isLoading } = useQuery({
    queryKey: ['notifications'],
    queryFn: () => listNotifications(false),
  });

  const markAll = useMutation({
    mutationFn: () => markNotificationsRead({ all: true }),
    onSuccess: () => { void queryClient.invalidateQueries({ queryKey: ['notifications'] }); },
  });

  const items = data?.items ?? [];

  return (
    <section className="panel">
      <div className="row" style={{ marginBottom: 4 }}>
        <h2 className="spacer">알림</h2>
        {(data?.unread_count ?? 0) > 0 && (
          <button className="btn btn--sm" onClick={() => { markAll.mutate(); }}>
            <IconCheck size={14} /> 모두 읽음
          </button>
        )}
      </div>
      <p className="panel__hint">공유 초대, 권한 변경 등 계정 관련 소식입니다.</p>

      {isLoading && <span className="spinner" />}
      {!isLoading && items.length === 0 && (
        <EmptyState title="알림이 없습니다" description="새 소식이 생기면 여기에 표시됩니다." />
      )}

      {items.map((item) => {
        const body = (
          <>
            <div className="row" style={{ gap: 6 }}>
              <IconShare size={14} className="faint" />
              <strong style={{ fontSize: 13 }}>{item.title}</strong>
              {!item.read_at && <span className="frow__badge">새 알림</span>}
            </div>
            {item.body && <div className="muted" style={{ fontSize: 13 }}>{item.body}</div>}
            <div className="faint" style={{ fontSize: 11 }}>{formatRelative(item.created_at)}</div>
          </>
        );

        return (
          <div key={item.id} className="panel__row">
            <div className="spacer">
              {item.link ? <Link to={item.link} style={{ color: 'inherit' }}>{body}</Link> : body}
            </div>
          </div>
        );
      })}
    </section>
  );
}
